import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Game } from "../../screens/GameScreen/utils/Game";

export interface GameState {
  game?: Game;
  gameRefUrl?: string;
}

const initialState: GameState = {
  game: undefined,
  gameRefUrl: undefined,
};

export const gameSlice = createSlice({
  name: "game",
  initialState,
  reducers: {
    setGame: (state, action: PayloadAction<Game | undefined>) => {
      state.game = action.payload;
    },
    setGameRefUrl: (state, action: PayloadAction<string | undefined>) => {
      state.gameRefUrl = action.payload;
    },
  },
});

export const { setGame, setGameRefUrl } = gameSlice.actions;

export default gameSlice.reducer;
